import Vue from 'vue'

export default {
  getBanners({ companyId }) {
    return Vue.http.get(`banner/company/${companyId}`)
  }
}
